import moment from 'moment';
import { html, css } from '~/lib/bn-lit-element';

import { sharedStyles } from '../styles/shared-styles';
import { AddToHomeScreenButton } from './a2hs-button';
import '../common/bn-icon';

const DISMISSAL_KEY = 'a2hs-dismissed';

class AddToHomeScreenToast extends AddToHomeScreenButton {
  constructor() {
    super();
    this.dismissed = window.localStorage.getItem(DISMISSAL_KEY);
    if (this.dismissed) {
      if (moment().subtract(3, 'months').isAfter(this.dismissed)) {
        window.localStorage.removeItem(DISMISSAL_KEY);
        this.dismissed = null;
      }
    }
  }

  static get properties() {
    return {
      dismissed: { type: String, attribute: false },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      :host {
        display: block;
      }
      .toast {
        background: var(--surface);
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        box-shadow: 0 -3px 3px -3px var(--gray-50);
        box-sizing: border-box;
        border-top: 1px solid var(--gray-40);
      }
      .toast .content {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        padding: 10px;
      }
      .toast .add-button {
        margin: 0 1em;
      }
      .toast p {
        margin: 1em;
      }
      .toast .close-button {
        float: right;
        margin: 10px;
      }
    `];
  }

  render() {
    if (!this.show || this.dismissed) {
      return html``;
    }
    return html`
      <div class="toast">
        <button class="button button--tertiary close-button" @click="${this._dismiss}">
          <bn-icon name="far fa-times"></bn-icon>
        </button>
        <div class="content">
          ${super.render()}
          <p>Add BinSentry to your home screen.</p>
        </div>
      </div>
    `;
  }

  connectedCallback() {
    super.connectedCallback();
    if (!this.dismissed) {
      this.dismissalTimeout = setTimeout(this._dismiss.bind(this), 1000 * 60 * 5); // auto dismiss after 5 minutes
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    clearTimeout(this.dismissalTimeout);
  }

  _dismiss() {
    this.dismissed = true;
    window.localStorage.setItem(DISMISSAL_KEY, moment().format());
    clearTimeout(this.dismissalTimeout);
  }
}

window.customElements.define('a2hs-toast', AddToHomeScreenToast);
